<app-enviar-token-firma-electronica (onOptionSelected)="onEnviarTokenFirmaElectronica($event)"></app-enviar-token-firma-electronica>
<app-token-enviado (onContinuar)="onContinuar($event)"></app-token-enviado>
<app-escriba-token-enviado 
  (onReenviarToken)="onReenviarToken($event)" 
  (onSubmitToken)="onSubmitToken($event)" 
  [btnSubmitLabel]="escribaTokenEnviadoBtnSubmitLabel"></app-escriba-token-enviado>
<app-tramite-firmado></app-tramite-firmado>

